{
  "login": {
    "subtitle": "Administration",
    "email_label": "Email address",
    "email_placeholder": "your.email@djayma.com",
    "password_label": "Password",
    "password_placeholder": "Your password",
    "submit": "Sign in",
    "submitting": "Signing in...",
    "footer": "Access restricted to Djayma managers",
    "error_invalid": "Incorrect email or password.",
    "error_network": "Connection error. Please try again.",
    "error_rate_limit": "Too many attempts. Please wait.",
    "error_unauthorized": "This account does not have Djayma admin access."
  },
  "nav": {
    "sections": {
      "principal": "Main",
      "commerce": "Commerce",
      "payments": "Payments",
      "delivery": "Delivery",
      "b2b": "B2B",
      "crm": "CRM",
      "marketing": "Marketing",
      "finance": "Finance",
      "operations": "Operations",
      "croissance": "Growth",
      "gestion": "Management",
      "analytique": "Analytics",
      "administration": "Administration",
      "settings": "Settings",
      "yoboulmako": "Yoboulmako",
      "djayma": "DJAYMA"
    },
    "dashboard": "Dashboard",
    "orders": "Orders",
    "products": "Products",
    "categories": "Categories",
    "inventory": "Inventory",
    "stock_alerts": "Stock alerts",
    "notifications": "Notifications",
    "payment_manager": "Payment manager",
    "reconciliation": "Reconciliation",
    "refunds": "Refunds",
    "disputes": "Disputes",
    "daily_cash": "Daily cash report",
    "delivery_board": "Assignment board",
    "drivers": "Drivers",
    "route_optimization": "Route optimization",
    "live_tracking": "Live tracking",
    "yango": "Yango",
    "delivery_zones": "Zones",
    "delivery_slots": "Time slots",
    "depots": "Depots",
    "delivery_performance": "Performance",
    "b2b_customers": "B2B accounts",
    "b2b_price_lists": "Price lists",
    "b2b_credit": "Credit lines",
    "b2b_approvals": "Approvals",
    "b2b_import": "Bulk import",
    "b2b_invoices": "B2B invoices",
    "b2b_aging": "Aging report",
    "suppliers": "Suppliers",
    "b2b_volume_discounts": "Volume discounts",
    "b2b_reps": "Sales reps",
    "clients_360": "Clients 360°",
    "segments": "Segmentation",
    "loyalty": "Loyalty",
    "whatsapp": "WhatsApp",
    "sms": "SMS",
    "feedback": "Feedback",
    "abandoned_carts": "Abandoned carts",
    "clv": "Customer lifetime value",
    "referrals": "Referrals",
    "communications": "Communications",
    "promotions": "Promotions",
    "coupons": "Coupons",
    "flash_sales": "Flash sales",
    "bundles": "Packs / Bundles",
    "banners": "Banners",
    "newsletter": "Newsletter",
    "seasonal": "Seasonal calendar",
    "stacking_rules": "Stacking rules",
    "promo_analytics": "Promo analytics",
    "tracking_links": "Social links",
    "revenue": "Revenue",
    "tva": "VAT",
    "margins": "Margins",
    "expenses": "Expenses",
    "invoices": "Invoices",
    "cashflow": "Cash flow",
    "sage_export": "Sage export",
    "powerbi": "Power BI",
    "reports": "Reports",
    "daily_pnl": "Daily P&L",
    "admin_users": "Admin users",
    "roles": "Roles & permissions",
    "audit_log": "Audit log",
    "tasks": "Tasks",
    "shifts": "Shifts",
    "agent_performance": "Agent performance",
    "announcements": "Announcements",
    "sla": "SLA",
    "incidents": "Incidents",
    "messages": "Messages",
    "clients": "Clients (CRM)",
    "finances": "Finances",
    "logistics": "Logistics",
    "returns": "Returns",
    "settings": "Settings",
    "modules": "Modules",
    "ai_dashboard": "AI Intelligence",
    "analytics_overview": "Overview",
    "demand_forecast": "Demand Forecast",
    "smart_pricing": "Smart Pricing",
    "churn_prediction": "Churn Prediction",
    "anomaly_detection": "Anomaly Detection",
    "replenishment": "Replenishment",
    "sales_insights": "Sales Insights",
    "recommendations": "Recommendations",
    "sentiment_analysis": "Sentiment Analysis",
    "model_monitor": "Model Monitor",
    "gdpr": "GDPR / Privacy",
    "einvoice": "E-Invoicing",
    "backup": "Backups",
    "api_keys": "API Keys",
    "webhooks": "Webhooks",
    "system_health": "System Health",
    "feature_flags": "Feature Flags",
    "data_export": "Data Export",
    "integrations_page": "Integrations",
    "operations_hub": "Operations",
    "error_dashboard": "Storefront Errors",
    "account_deletions": "Account Deletions",
    "crm": "CRM",
    "marketing_hub": "Marketing",
    "b2b_hub": "B2B",
    "finance_hub": "Finance",
    "analytics_trending": "Trending",
    "analytics_search": "Search",
    "analytics_funnel": "Funnel",
    "analytics_intent": "Intent",
    "content": "Content",
    "privacy": "Privacy",
    "enterprise": "Enterprise",
    "lancement": "Launch Day",
    "yoboulmako_dashboard": "Dashboard",
    "yoboulmako_livraisons": "Live Deliveries",
    "yoboulmako_dispatches": "Expéditions",
    "yoboulmako_clients": "Clients",
    "yoboulmako_facturation": "Billing",
    "yoboulmako_parametres": "Settings",
    "djayma_control_tower": "Control tower",
    "djayma_finance": "Reconciliation",
    "djayma_call_center": "Shop 360",
    "djayma_stock": "Stock",
    "djayma_orders": "Orders",
    "djayma_logistique": "Logistics",
    "djayma_pricing": "Price book",
    "djayma_promotions": "Promotions",
    "djayma_partners": "Partners",
    "djayma_channels": "Channels",
    "djayma_access": "Access"
  },
  "header": {
    "title": "Djayma Administration",
    "admin_label": "Administrator"
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome to the administration panel",
    "error": "Unable to load dashboard data. Please try again.",
    "kpi": {
      "revenue_today": "Revenue today",
      "orders_today": "Orders today",
      "aov": "Average order value",
      "pending_payments": "Pending payments"
    },
    "charts": {
      "revenue_title": "Revenue trend",
      "orders_by_status_title": "Orders by status",
      "top_products_title": "Top 5 products by revenue",
      "region_revenue_title": "Revenue by region",
      "revenue_label": "Revenue",
      "orders_label": "Orders",
      "no_data": "No data for this period"
    }
  },
  "actions": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "search": "Search",
    "filter": "Filter",
    "export": "Export",
    "create": "Create",
    "back": "Back",
    "confirm": "Confirm",
    "close": "Close"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "pending": "Pending",
    "approved": "Approved",
    "rejected": "Rejected",
    "processing": "Processing",
    "completed": "Completed",
    "cancelled": "Cancelled"
  },
  "orders": {
    "title": "Orders",
    "subtitle": "Manage your customer orders",
    "col_reference": "Reference",
    "col_client": "Customer",
    "col_amount": "Total incl. tax",
    "col_status": "Status",
    "col_payment": "Payment",
    "col_date": "Date",
    "col_actions": "Actions",
    "filter_status": "Status",
    "filter_payment": "Payment",
    "filter_region": "Region",
    "search_placeholder": "Search by ref, customer, phone...",
    "action_view": "View order",
    "action_view_short": "View",
    "empty": "No orders found.",
    "error_loading": "Unable to load orders.",
    "error_hint": "Check your connection and try again.",
    "retry": "Retry",
    "clear_filters": "Clear filters",
    "result_count_one": "{{count}} order found",
    "result_count_other": "{{count}} orders found",
    "bulk_confirm": "Confirm",
    "bulk_cancel": "Cancel",
    "bulk_confirmed_one": "{{count}} order confirmed",
    "bulk_confirmed_other": "{{count}} orders confirmed",
    "bulk_cancelled_one": "{{count}} order cancelled",
    "bulk_cancelled_other": "{{count}} orders cancelled",
    "bulk_partial_failure_one": "{{count}} order could not be updated",
    "bulk_partial_failure_other": "{{count}} orders could not be updated",
    "bulk_error": "Unable to update orders.",
    "status": {
      "pending": "Pending",
      "confirmed": "Confirmed",
      "processing": "Processing",
      "shipped": "Shipped",
      "delivered": "Delivered",
      "cancelled": "Cancelled",
      "cancelled_timeout": "Cancelled (timeout)",
      "payment_failed": "Payment failed"
    },
    "payment_method": {
      "wave": "Wave",
      "orange_money": "Orange Money",
      "carte": "Credit card",
      "especes": "Cash",
      "virement": "Bank transfer"
    }
  },
  "placeholder": {
    "coming_soon": "Module under development",
    "coming_soon_description": "This module will be available soon."
  },
  "order_detail": {
    "title": "Order {{ref}}",
    "back_to_orders": "Back to orders",
    "created_at": "Created on",
    "customer": "Customer",
    "phone": "Phone",
    "email": "Email",
    "delivery_address": "Delivery address",
    "region": "Region",
    "payment_method": "Payment method",
    "subtotal_ht": "Subtotal excl. tax",
    "tax": "Tax",
    "delivery_fee": "Delivery",
    "total_ttc": "Total incl. tax",
    "items": "Items",
    "col_product": "Product",
    "col_sku": "SKU",
    "col_qty": "Qty",
    "col_unit_price": "Unit price",
    "col_line_total": "Line total",
    "timeline": "History",
    "notes": "Notes",
    "add_note": "Add a note",
    "note_placeholder": "Enter your note...",
    "note_submit": "Send",
    "note_empty": "No notes for this order.",
    "actions_title": "Actions",
    "no_actions_available": "No actions available for this order.",
    "confirm_order": "Confirm",
    "cancel_order": "Cancel",
    "process_order": "Start preparation",
    "ship_order": "Ship",
    "deliver_order": "Mark delivered",
    "retry_payment": "Retry payment",
    "print_delivery_slip": "Print delivery slip",
    "initiate_refund": "Initiate refund",
    "confirm_status_title": "Confirm status change",
    "confirm_status_message": "Do you want to change the order status to \"{{status}}\"?",
    "confirm_status_yes": "Confirm",
    "confirm_status_no": "Cancel",
    "error_loading": "Unable to load order.",
    "error_status_update": "Unable to update status.",
    "error_add_note": "Unable to add note.",
    "success_status_update": "Status updated successfully.",
    "success_note_added": "Note added.",
    "not_found": "Order not found",
    "not_found_description": "The requested order does not exist or has been deleted.",
    "no_items": "No items",
    "delivery": "Delivery",
    "driver": "Driver",
    "delivery_status": "Delivery status",
    "payments": "Payments",
    "payment_ref": "Ref.",
    "payment_amount": "Amount",
    "payment_status": "Status",
    "payment_date": "Date"
  },
  "bulk_orders": {
    "confirm": "Confirm",
    "ship": "Ship",
    "deliver": "Mark delivered",
    "cancel": "Cancel",
    "confirm_title": "Confirmation",
    "confirm_dialog": "Are you sure you want to {{action}} {{count}} orders?",
    "processing": "Processing…",
    "success": "{{count}} order(s) updated",
    "all_failed": "No orders updated. Check the statuses.",
    "partial_success": "{{updated}} order(s) updated. {{failed}} failure(s).",
    "error": "Error: {{message}}",
    "undo": "Undo",
    "undone": "Update reverted",
    "undo_failed": "Unable to revert the update"
  },
  "returns": {
    "col_order": "Order",
    "col_date": "Date",
    "col_reason": "Reason",
    "col_status": "Status",
    "col_refund": "Refund",
    "col_actions": "Actions",
    "filter_all": "All statuses",
    "empty": "No return requests",
    "error_loading": "Unable to load returns.",
    "error_generic": "An error occurred. Please try again.",
    "action_review": "Review",
    "action_view": "View",
    "modal_title": "Process return",
    "action_approve": "Approve",
    "action_reject": "Reject",
    "refund_amount_label": "Refund amount (FCFA)",
    "refund_method_label": "Refund method",
    "admin_notes_label": "Internal note (optional)",
    "admin_notes_placeholder": "Comment visible to the team only…",
    "pagination_info": "Page {{page}} / {{total_pages}} — {{total}} request(s)",
    "prev_page": "Previous page",
    "next_page": "Next page"
  },
  "stock_alerts": {
    "title": "Stock alert rules",
    "add_rule": "Add rule",
    "create_rule_title": "New alert rule",
    "edit_rule_title": "Edit alert rule",
    "col_scope": "Product / Category",
    "col_threshold": "Threshold",
    "col_channels": "Channels",
    "col_auto_reorder": "Auto-reorder",
    "col_status": "Status",
    "col_actions": "Actions",
    "auto_reorder_on": "Auto",
    "field_scope": "Scope",
    "scope_product": "Product",
    "scope_category": "Category",
    "field_product": "Product",
    "product_placeholder": "Product ID",
    "field_category": "Category",
    "category_placeholder": "Category ID",
    "field_threshold": "Minimum stock threshold",
    "field_channels": "Notification channels",
    "field_auto_reorder": "Auto-reorder",
    "auto_reorder_tooltip": "Automatically create a purchase order",
    "field_active": "Rule active",
    "confirm_delete": "Are you sure you want to delete this alert rule?",
    "error_loading": "Unable to load alert rules.",
    "empty_title": "No alert rules",
    "empty_description": "Create your first rule to be alerted when stock is low."
  },
  "categories": {
    "page_title": "Categories",
    "page_description": "Organize your products into categories and subcategories (3 levels max).",
    "add": "New category",
    "create_title": "Create a category",
    "edit_title": "Edit category",
    "empty": "No categories",
    "empty_hint": "Create your first category to organize your products.",
    "error_loading": "Unable to load categories.",
    "expand": "Expand",
    "collapse": "Collapse",
    "add_child": "Add subcategory",
    "product_count_one": "{{count}} product",
    "product_count_other": "{{count}} products",
    "product_count": "{{count}} product(s)",
    "field_name_fr": "Name (French)",
    "field_name_wo": "Name (Wolof)",
    "field_name_en": "Name (English)",
    "field_slug": "Slug",
    "field_parent": "Parent category",
    "field_image": "Image (URL)",
    "field_active": "Category active",
    "placeholder_name_fr": "E.g.: Dairy products",
    "placeholder_name_wo": "E.g.: Meew",
    "placeholder_name_en": "E.g.: Dairy products",
    "no_parent": "— None (root) —",
    "select_parent": "Choose a category...",
    "delete_title": "Delete category",
    "delete_confirm": "Are you sure you want to delete \"{{name}}\"?",
    "delete_has_products": "This category contains {{count}} product(s). They will be detached.",
    "delete_has_children": "This category has {{count}} subcategory(ies). What would you like to do?",
    "move_children_to": "Move subcategories to...",
    "delete_all_children": "Delete everything (category + subcategories)",
    "deleting": "Deleting..."
  },
  "images": {
    "image": "Image",
    "primary": "Primary",
    "is_primary": "Primary image",
    "set_primary": "Set as primary",
    "delete": "Delete",
    "confirm_delete": "Confirm deletion",
    "deleted": "Image deleted",
    "add": "Add",
    "upload_success": "Image uploaded successfully",
    "max_reached": "Maximum {{max}} images per product",
    "count": "{{current}} / {{max}} images",
    "empty_title": "No images",
    "empty_description": "Click to add images to the product",
    "select_files": "Select files",
    "invalid_type": "Unsupported file type. Accepted formats: JPEG, PNG, WebP, AVIF.",
    "file_too_large": "File exceeds the maximum size of {{max}} MB",
    "upload_error": "Error uploading image",
    "reorder_error": "Error reordering images"
  },
  "products": {
    "stock": {
      "drawer_title": "Stock adjustment",
      "current_stock": "Current stock",
      "threshold": "Alert threshold",
      "threshold_default": "Threshold: {{value}} (default)",
      "threshold_custom": "Threshold: {{value}} (custom)",
      "direction_reception": "Receive (+)",
      "direction_sortie": "Out (-)",
      "direction_correction": "Correction (+/-)",
      "quantity": "Quantity",
      "reason": "Reason",
      "reason_restock": "Restock",
      "reason_sale": "Sale",
      "reason_return": "Return",
      "reason_adjustment": "Adjustment",
      "notes": "Notes",
      "notes_required": "Notes required for adjustments",
      "preview": "{{from}} → {{to}} ({{delta}})",
      "confirm": "Confirm adjustment",
      "success": "Stock updated successfully",
      "error_insufficient": "Insufficient stock for this operation",
      "history_title": "Movement history",
      "history_empty": "No movements recorded",
      "history_full_link": "View full history",
      "history_filter_reason": "Filter by reason",
      "history_filter_date": "Filter by date"
    },
    "conflict": {
      "title": "Version conflict",
      "message": "Stock was modified by {{actor}} {{time}} ago.",
      "your_stock": "Stock when you opened",
      "current_stock": "Current stock",
      "your_change": "Your change",
      "option_apply": "Apply my {{delta}} to the new stock → {{result}}",
      "option_keep": "Keep the new stock ({{current}}, discard my change)",
      "option_cancel": "Cancel",
      "apply_choice": "Apply my choice"
    },
    "bulk": {
      "selected": "{{count}} product(s) selected",
      "deselect": "Deselect",
      "select_all_page": "All {{count}} products on this page are selected.",
      "select_all_filtered": "Select all {{count}} filtered products",
      "activate": "Activate",
      "deactivate": "Deactivate",
      "price": "Price",
      "category": "Category",
      "threshold": "Low threshold",
      "export_csv": "Export CSV",
      "delete": "Delete",
      "confirm_activate": "Activate {{count}} product(s)",
      "confirm_deactivate": "Deactivate {{count}} product(s)",
      "confirm_delete": "Delete {{count}} product(s)",
      "typed_confirm_prompt": "To confirm, type the exact number:",
      "typed_confirm_warning": "This action can be undone within 5 seconds.",
      "price_mode_absolute": "Absolute price",
      "price_mode_percent": "Percentage",
      "price_preview_old": "Old price",
      "price_preview_new": "New price",
      "price_reason": "Reason for price change",
      "category_select": "New category",
      "threshold_input": "New threshold",
      "threshold_reset": "Reset to default",
      "pending_approval": "Pending approval by Direction",
      "undo_toast": "Undo ({{seconds}}s)",
      "undo_success": "Action undone"
    },
    "command_palette": {
      "placeholder": "Search a product or action...",
      "adjust_stock": "Adjust stock for...",
      "mark_out": "Mark out of stock...",
      "export_view": "Export current view",
      "new_product": "New product",
      "import_csv": "Import CSV",
      "stock_alerts": "Stock alerts overview",
      "pending_approvals": "View pending approvals",
      "no_results": "No results"
    },
    "keyboard": {
      "cheatsheet_title": "Keyboard shortcuts",
      "nav_up": "Previous row",
      "nav_down": "Next row",
      "toggle_select": "Select / deselect",
      "select_all": "Select all (page)",
      "clear": "Clear selection / close",
      "edit": "Edit product",
      "stock_drawer": "Open stock drawer",
      "command_palette": "Command palette",
      "focus_search": "Focus search",
      "show_shortcuts": "Show shortcuts"
    },
    "alerts": {
      "title": "Stock alerts",
      "out_of_stock": "out of stock",
      "low_stock": "low stock",
      "view_all": "View all products in alert"
    },
    "approvals": {
      "title": "Pending approvals",
      "empty": "No pending approvals",
      "approve": "Approve",
      "reject": "Reject",
      "reject_reason": "Rejection reason",
      "approved_success": "Action approved and executed",
      "rejected_success": "Action rejected",
      "expires_in": "Expires in {{time}}",
      "expired": "Expired",
      "maker": "Requester",
      "action": "Action",
      "affected": "Affected products"
    },
    "table": {
      "presence_editing": "{{name}} is editing this product",
      "realtime_updated": "Updated by {{name}}",
      "sort_asc": "Sort ascending",
      "sort_desc": "Sort descending"
    },
    "error_boundary": {
      "title": "Unexpected error",
      "message": "Something went wrong while loading the products.",
      "retry": "Retry",
      "report": "Report the issue"
    }
  }
}
